import axios from "@/axios";

export default async function validateAccessCode(accessCode: string) {
    return await axios.post('/accounts/user/validate-access-code', {
        access_code: accessCode
    });
}
